import React from 'react';
import { SubTitle } from 'components/uiParts/SubTitle';
import { CreateForm } from 'components/uiParts/Form/CreateForm';
import { Breadcrumb } from 'components/uiParts/Breadcrumb';
// 定数ファイル
import { CUSTOMER_CATEGORY_COLUMNS } from 'utils/constantsTable';
// MUI
import Button from '@mui/material/Button';

export const CustomerCategory1CreatePage = () => {
  const breadcrumbList = [
    { name: 'ダッシュボード', href: '/' },
    { name: '得意先区分1一覧', href: '/customerCategory1/list' },
    { name: '得意先区分1登録' },
  ];
  return (
    <>
      <Breadcrumb breadcrumbList={breadcrumbList} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SubTitle title='得意先区分1登録' />
        <Button
          href={location.origin + '/customerCategory1/list'}
          variant='contained'
          color='inherit'
        >
          戻る
        </Button>
      </div>
      <CreateForm
        api='CustomerCategory1'
        columns={CUSTOMER_CATEGORY_COLUMNS}
        input={{
          name: '',
          remarks: '',
        }}
        redirectUrl='/customerCategory1/list'
      />
    </>
  );
};
